import { render, staticRenderFns } from "./VerifyStatusAccountToken.vue?vue&type=template&id=273b28c4&"
import script from "./VerifyStatusAccountToken.vue?vue&type=script&lang=js&"
export * from "./VerifyStatusAccountToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273b28c4')) {
      api.createRecord('273b28c4', component.options)
    } else {
      api.reload('273b28c4', component.options)
    }
    module.hot.accept("./VerifyStatusAccountToken.vue?vue&type=template&id=273b28c4&", function () {
      api.rerender('273b28c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customer/VerifyStatusAccountToken.vue"
export default component.exports